<template>
    <CategorySection title="Обучение">
        <template>
            <CardCourse
                v-for="event in events"
                :key="`${entityKey}-${event.id}`"
                :course="event"
                :expandedEntityId="expandedEntityId"
                :hideStatus="hideStatus"
                @onExpandedTags="(val) => $emit('onExpandedTags', val)"
            />
            <MoreButton
                v-if="eventsCount > events.length"
                :isLoading="isLoadingEvents"
                :disabled="isLoadingEvents"
                @click="$emit('onFetchMore')"
            />
        </template>
    </CategorySection>
</template>

<script>
import CategorySection from '../parts/CategorySection.vue';
import CardCourse from '@/views/track/components/cards/CardCourse.vue';
import MoreButton from '../parts/MoreButton.vue';

export default {
    name: 'TabRecommendations',
    components: {
        CategorySection,
        CardCourse,
        MoreButton,
    },
    props: {
        events: {
            type: Array,
            required: true,
        },
        eventsCount: {
            type: Number,
            required: true,
        },
        hideStatus: {
            type: Boolean,
            default: false,
        },
        isLoadingEvents: {
            type: Boolean,
            default: false,
        },
        expandedEntityId: {
            type: [String, Number],
            default: null,
        },
        entityKey: {
            type: String,
            default: 'events',
        },
    },
};
</script>
